<template>
  <div
    v-if="hasTwoDContent && hasThreeDContent"
    class="buttons has-addons toc-content-tabs"
    role="tablist"
    :aria-label="$t('content')"
  >
    <button
      class="button is-small"
      :class="{ 'is-primary': activeContent === '2d' }"
      :aria-selected="activeContent === '2d'"
      data-unit="toc-2d-content-tab"
      role="tab"
      type="button"
      @click="selectContent('2d')"
    >
      <span class="icon is-small"><i class="fas fa-book" /></span>
      <span>{{ $t('twoDContent') }}</span>
      <span
        v-if="hasQuery"
        class="tag is-light"
        data-unit="toc-2d-result-count"
      >
        {{ twoDResultCount }}
      </span>
    </button>
    <button
      class="button is-small"
      :class="{ 'is-primary': activeContent === '3d' }"
      :aria-selected="activeContent === '3d'"
      data-unit="toc-3d-content-tab"
      role="tab"
      type="button"
      @click="selectContent('3d')"
    >
      <span class="icon is-small"><i class="fas fa-cube" /></span>
      <span>{{ $t('threeD.content') }}</span>
      <span
        v-if="hasQuery"
        class="tag is-light"
        data-unit="toc-3d-result-count"
      >
        {{ threeDResultCount }}
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const activeContent = computed(() => store.state.content.toc.activeContent)
const hasThreeDContent = computed(() => store.state.content.toc.threeDModelSnapshots.length > 0)
const hasTwoDContent = computed(() => store.state.content.toc.items.length > 0)
const hasQuery = computed(() => Boolean(store.state.content.toc.query?.trim()))
const threeDResultCount = computed(() => store.state.content.toc.threeDResultCount || 0)
const twoDResultCount = computed(() => store.state.content.toc.twoDResultCount || 0)

function selectContent (activeContent: '2d' | '3d') {
  store.dispatch('content/updateTocActiveContent', activeContent)
}
</script>

<style scoped>
.toc-content-tabs {
  justify-content: center;
  margin-bottom: 0.75rem;
}

.toc-content-tabs .button {
  flex: 1;
}
</style>
